import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Route } from "react-router-dom";
import { signinRedirect } from "../services/AuthenticationService";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";

export const PrivateRoute = ({ component: Component = null, render: Render = null, ...rest }) => {
  const user = useSelector(state => state.auth.user)

  useEffect(() => {
    if (!user) {
      signinRedirect()
    }
  }, [user]);
  return (
    <Route
      {...rest}
      render={props =>
        user ? (
          Render ? (
            Render(props)
          ) : Component ? (
            <Component {...props} />
          ) : null
        ) : (
            // signinRedirect()
            <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
          )
      }
    />
  );
};
